<auth-splash-page>
  @if (colorMode.currentMode() === 'dark') {
    <img
      src="/assets/img/compass-logo-dark.png"
      class="align-self-center"
      alt="Compass logo"
      width="245"
      height="245"
    />
    <img src="/assets/img/brand-text-dark.png" class="mb-3" alt="CRST Compass" width="304" height="54" />
  } @else {
    <img src="/assets/img/compass-logo.png" class="align-self-center" alt="Compass logo" width="245" height="245" />
    <img src="/assets/img/brand-text.png" class="mb-3" alt="CRST Compass" width="304" height="54" />
  }
  <div class="text-primary fw-bold text-center mb-3">Account: {{ temporarySession().maskedEmail }}</div>
  <h1 class="text-center mb-2">Enter New Password</h1>
  <p class="text-center mx-auto">
    Strong passwords include things such as numbers, a variety of uppercase & lowercase letters, and symbols
  </p>
  <form #resetPasswordForm="ngForm" class="d-grid" (ngSubmit)="submitPassword()">
    <auth-new-password [formData]="formData" />
    <button matButton="filled" type="submit" [disabled]="resetPasswordForm.invalid">Confirm</button>
  </form>
</auth-splash-page>
